import type { Level } from 'pino';
import {
  createLogger,
  createContextLogger as _createContextLogger,
  StaticLogger,
} from '@sukha/logger';

/** Prefer `info` over the shared library default (`debug` in dev) to reduce noise; set LOG_LEVEL when you need traces. */
const level: Level =
  process.env.LOG_LEVEL && process.env.LOG_LEVEL.length > 0
    ? (process.env.LOG_LEVEL as Level)
    : 'info';

const logger = createLogger({
  processLabel: 'web',
  isDev: process.env.NODE_ENV === 'development',
  level,
  base: { pid: process.pid },
});

/**
 * Creates a child logger with a specific context/module name.
 *
 * @param context - The module or component name (e.g., 'EmailService', 'CronJob')
 * @returns A child logger with the context included in all logs
 */
export function createContextLogger(context: string) {
  return _createContextLogger(logger, context);
}

/**
 * Static Logger class for backward compatibility with existing code.
 * Supports `Logger.debug(message, ...args)` style calls.
 */
const Logger = new StaticLogger(logger);

export default Logger;
